module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch2"
    }
  }, [_c('p', {
    staticClass: "Head1"
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('p', {
    staticClass: "chapterTitle1"
  }, [_vm._v("Medieval Murder")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("E")]), _vm._v("vidence of murder in the Island during the Middle Ages comes to us directly from one source only – the coroner’s court proceedings from July 1377 to Michaelmas (Autumn) 1392. It lists forty-two cases and it would be fascinating to compare these years with earlier periods. This was, after all, the ‘hurling time’ of the Hundred Years’ War and the Peasants’ Revolt; was this a worse time than any other as far as Island serious crime was concerned?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Until her death in 1293, the redoubtable Isabella de Fortibus was the Lady of the Wight and ruled the place as her private domain from Carisbrooke Castle. Widowed at twenty-three, the murder of her brother Baldwin (de Redvers) two years later catapulted her into the arena of male-dominated politics. For most of her rule, she was in constant litigation with abbeys and other landholders over rights and was regularly involved in other legal wrangles. She also acted as coroner, which was usually a role reserved for the king’s appointee, and even after Edward I acquired the Island from Isabella on her deathbed, the Governor of the Island continued to act as coroner in his own right, as well as bailiff and sheriff.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f19d45","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/16_ch2.vue
// module id = 99
// module chunks = 0